import { setUpAnalyticsChoice } from './analytics-choice';
import { analytics, offerConsent } from './index';

// The content pages' analytics script (a build entry, see vite.config.ts); its tag names the privacy page to link to.
const script = document.querySelector<HTMLScriptElement>('script[data-analytics]');
const choice = document.querySelector<HTMLElement>('[data-analytics-choice]');

analytics.start();
offerConsent(document.documentElement.lang, script?.dataset.privacy ?? '/privacy/#analytics');
if (choice) setUpAnalyticsChoice(choice, analytics);
